import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash/fp';

const WindowFlagNotes = ({ flagNotes }) => (
  <div className="itemProduct">
    {map(note => (
      <div className="flaggedWindowNote" key={note.id}>
        <h5>Flagged Note</h5>
        <p>{note.content}</p>
      </div>
     ))(flagNotes)}
  </div>
);

WindowFlagNotes.propTypes = {
  flagNotes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
  })).isRequired,
};

export default WindowFlagNotes;
